import { render, staticRenderFns } from "./SCoupon.vue?vue&type=template&id=f2ade87a&scoped=true"
import script from "./SCoupon.vue?vue&type=script&lang=js"
export * from "./SCoupon.vue?vue&type=script&lang=js"
import style0 from "./SCoupon.vue?vue&type=style&index=0&id=f2ade87a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2ade87a",
  null
  
)

export default component.exports